import { useMemo } from 'react';
import { Child, useGetSinglePage } from 'react-easyrocket';
import { useLocation } from 'react-router';
import { SUPPORTED_LANGUAGES } from 'src/modules/locales/config';

type UseGetSeoPageData = () => Child | undefined;

export const useGetSeoPageData: UseGetSeoPageData = () => {
  const { childs } = useGetSinglePage('seo_pages');
  const { pathname } = useLocation();

  const seoPageData = useMemo(() => {
    const pathArr = pathname.split('/');
    const path = defineIsMainPage(pathname) ? 'main' : pathArr[pathArr.length - 1] || 'main';
    return (
      childs?.find((child) => {
        return path.includes(child.code.split('seo_')[1]);
      }) || childs?.find((child) => child.code === 'seo_main')
    );
  }, [childs, pathname]);
  return seoPageData;
};

function defineIsMainPage(pathname: string) {
  const regexp = RegExp(
    `^/(${Object.keys(SUPPORTED_LANGUAGES)
      .map((l) => `${l}`)
      .join('|')})?/?$`
  );
  return regexp.test(pathname);
}
